import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { Status } from "../../../common/constants";

interface ISpinner {
    isActive: boolean;
    apiStatus?: string[]
}

const SPINNER = "spinner";

const initialState: ISpinner = {
    isActive: false,
    apiStatus: []
};

const spinnerSlice = createSlice({
    name: SPINNER,
    initialState,
    reducers: {
        showSpinner: (state: ISpinner) => {
            state.isActive = true;
        },
        hideSpinner: (state: ISpinner) => {
            state.isActive = false;
        },
        setApiStatus(state, action) {
            const { payload } = action;
            if (payload == Status.SUCCESS || payload == Status.FAILED) {
                const pendingIndex = state.apiStatus.findIndex(status => status == Status.PENDING);
                if (pendingIndex !== -1) {
                    state.apiStatus.splice(pendingIndex, 1);
                }
            }
            state.apiStatus.push(payload);
        },
    }
});

export const actions = {
    spinnerSlice,
    ...spinnerSlice.actions,
};

export const selector = (state: RootState) => state.spinner;

export const reducer = spinnerSlice.reducer;
